import { http } from '@packet/management/src/api/http';
import { Hash } from 'viem';
import { PaginationParams, PaginationResponse } from '.';
import { CommitmentBaseDto, TransactionBaseDto } from '@/types/commitment';

export type ITransaction = TransactionBaseDto<CommitmentBaseDto>;
export type CommitmentDetail = CommitmentBaseDto & {
  from: Array<TransactionBaseDto>;
  to: Array<TransactionBaseDto>;
};

/**
 * commitment get
 */
export const getCommitmentById = async (commitment: string[]) => {
  return http().get<CommitmentDetail[]>('/api/v1/viewing/utxo/get', { commitment });
};

/**
 * 获取 commitment 列表
 */
export const getCommitmentList = async (params: PaginationParams & { address: string; chain_id?: number; order?: 'asc' | 'desc'; is_frozen?: boolean; is_spent?: boolean }) => {
  return http().get<PaginationResponse<CommitmentDetail>>('/api/v1/viewing/utxo/list', params);
};

/**
 * 获取 transaction 详情
 */
export const getTransactionById = async (txhash: Hash, tx_index: number) => {
  return http().get<ITransaction>('/api/v1/viewing/transactions/get', {
    txhash,
    tx_index,
  });
};

/**
 * 获取 transaction 列表
 */

interface IGetTransactionListParams extends PaginationParams {
  address: string;
  chain_id: number;
  tx_type?: number;
  asset?: string;
  begin_time?: number;
  end_time?: number;
  order?: 'asc' | 'desc';
}

export const getTransactionList = async (params: IGetTransactionListParams) => {
  const res = await http().get<PaginationResponse<ITransaction>>('/api/v1/viewing/transactions/list', params);
  return res;
};
